<template>
    <div>
        <Button
            :loading="apiFormRef?.loading.valueOf()"
            @click="submit()"
            :iconName="iconName"
            color="light"
            size="small"
        />
        <ApiForm
            :url="route"
            method="POST"
            ref="apiFormRef"
            :disableCatch="true"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import ServiceID from '@/App/Service/Entity/ServiceID'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'

    const emits = defineEmits<{
        onSuccess: [ServiceAggregate]
    }>()

    const props = defineProps({
        serviceId: {
            type: Object as PropType<ServiceID>,
            required: true,
        },
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        moveUp: {
            type: Boolean,
            required: true,
        },
    })

    const isOpen = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const iconName = props.moveUp ? 'arrow-up' : 'arrow-down'
    const urlFactory = new UrlFactory()

    const route = props.moveUp
        ? urlFactory.makeServiceCustomFieldMoveUpUrl(
              props.serviceId,
              props.customField.id,
          )
        : urlFactory.makeServiceCustomFieldMoveDownUrl(
              props.serviceId,
              props.customField.id,
          )

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                emits(
                    'onSuccess',
                    response.getHydratedServiceAggregate(
                        ResponseJsonKeyEnum.App_CustomFields_Move_ServiceAggregateData,
                    ),
                )
            })
            ?.finally(() => {
                isOpen.value = false
            })
    }
</script>
